import PropTypes from "prop-types";
import React from "react";

const UnitNumberField = ({unitNumber, changeHandler}) => (
  <label className="unitNumber">
    Apartment, Unit, Floor, Etc
    <br />
    <input
      className="unit-number-field"
      id="unitNumber"
      name="unitNumber"
      onChange={changeHandler}
      type="text"
      value={unitNumber}
    />
  </label>
);

UnitNumberField.propTypes = {
  "changeHandler": PropTypes.func.isRequired,
  "unitNumber": PropTypes.string
};

UnitNumberField.defaultProps = {"unitNumber": ""};

export default UnitNumberField;
